// extracted by mini-css-extract-plugin
module.exports = {"tabs":"styles_tabs__lgU7_","wiggle":"styles_wiggle__zeW3d","pulse":"styles_pulse__xzDvM","jump":"styles_jump___N557"};